import { Link, useLocation } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';

const ROUTE_LABELS: Record<string, string> = {
  dashboard: 'Dashboard',
  invoices: 'Invoices',
  contacts: 'Contacts',
  partners: 'Partners',
  khata: 'Digital Khata',
  expenses: 'Expenses',
  reports: 'Reports',
  aging: 'Aging Reports',
  cashbook: 'Cash Book',
  'vat-report': 'VAT Report',
  inventory: 'Inventory',
  'damaged-goods': 'Damaged Goods',
  'demand-forecast': 'Demand AI',
  purchase: 'Purchase',
  pos: 'Point of Sale',
  terminal: 'Terminal',
  hr: 'HR Management',
  'my-attendance': 'My Attendance',
  'my-leaves': 'My Leaves',
  'my-payslips': 'My Payslips',
  assistance: 'HR Assistance',
  projects: 'Projects',
  timesheets: 'Timesheets',
  team: 'Team Management',
  settings: 'Business Settings',
  'business-profile': 'Business Profile',
};

export const Breadcrumbs = () => {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter(x => x);

  if (pathnames.length <= 1) return null;

  return (
    <nav className="flex items-center gap-1 text-sm text-muted-foreground mb-4">
      <Link
        to="/dashboard"
        aria-label="Dashboard"
        className="rounded-sm hover:text-foreground transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
      >
        <Home className="h-3.5 w-3.5" />
      </Link>
      {pathnames.map((name, index) => {
        const routeTo = `/${pathnames.slice(0, index + 1).join('/')}`;
        const isLast = index === pathnames.length - 1;
        const label = ROUTE_LABELS[name] || name.charAt(0).toUpperCase() + name.slice(1);

        return (
          <span key={routeTo} className="flex items-center gap-1">
            <ChevronRight className="h-3 w-3 text-muted-foreground/50" />
            {isLast ? (
              <span className="font-medium text-foreground">{label}</span>
            ) : (
              <Link
                to={routeTo}
                className="rounded-sm hover:text-foreground transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
              >
                {label}
              </Link>
            )}
          </span>
        );
      })}
    </nav>
  );
};
